import { useEffect, useState } from "react";
import "react-quill/dist/quill.snow.css";
import Loader from "../Loader/Loader";
import ReactQuill from "react-quill";

import { getAboutUs, updateAboutUs, createAboutUs } from "../../Web Apis/webApis"
import { message } from "antd";

const About = () => {
  const [updating, setUpdating] = useState(false);
  const [data, setData] = useState(null); // Initialize as null to differentiate between no data and default
  const [text, setText] = useState("");
  const [disableStatus, setDisableStatus] = useState(true);


  const sentHtml = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  }

  const getAboutUsApi = async () => {
    setUpdating(true);
    try {
      const response = await getAboutUs();
      if (response?.data?.success && response?.data?.data?.length > 0) {
        
        const aboutUsData = response?.data?.data[0];
        setData(aboutUsData);
        setText(aboutUsData?.content);
      } else {
        setData(null); // No "About Us" data found
      }
    } catch (error) {
     
      console.error("Error fetching About Us:", error);
      if (error.message === 'Network Error' || error.message.includes('ERR_INTERNET_DISCONNECTED')) {
              // Handle internet disconnection
              return;
            }
            // Handle specific error cases
            if (error?.response?.status === 401) {
              window.alert("Your account is logged in to another device, please login again !")
              localStorage.removeItem('token');
              // setIsAuthenticated(false)
              window.location.href = "/login";
            }
            if (error?.response?.status === 500) {
              message.error("Server not responding")
              return;
            }
            else {
              
              return;
            }
      // message.error(error?.response?.data?.message || "Error while fetching About Us");
    } finally {
      setUpdating(false);
    }
  };

  const createAboutUsApi = async () => {

    const plainText = sentHtml(text).trim();

    if(!plainText){
      message.error("Content can not be empty")
      return ;
    }

    setUpdating(true);
    try {
      const response = await createAboutUs({ content: text });
      if (response?.data?.success) {
        message.success(response?.data?.message);
        await getAboutUsApi(); // Refresh the "About Us" data after creation
      }
    } catch (error) {
      console.error("Error while creating About Us:", error);
       if (error.message === 'Network Error' || error.message.includes('ERR_INTERNET_DISCONNECTED')) {
                      // Handle internet disconnection
                      return;
                  }
                  // Handle specific error cases
                  if (error?.response?.status === 401) {
                      window.alert("Your account is logged in to another device, please login again !")
                      localStorage.removeItem('token');
                      window.location.href="/login"
                  }
                  if (error?.response?.status === 500) {
                      message.error("Server not responding")
                  } else {
                    return ;
                  }
    } finally {
      setUpdating(false);
    }
  };

  const updateAboutUsApi = async () => {
    const plainText = sentHtml(text).trim();

    if(!plainText){
      message.error("Content can not be empty")
      return ;
    }

    setUpdating(true);
    try {
      const response = await updateAboutUs(data.id, { content: text });
      if (response?.data?.success) {
        message.success(response?.data?.message);
        setDisableStatus(true);
      }
    } catch (error) {
      console.error("Error while updating About Us:", error);
      message.error(error?.response?.data?.message || "Error in updating About Us");
    } finally {
      setUpdating(false);
    }
  };

  useEffect(() => {
    getAboutUsApi();
  }, []);

  const handleChange = (value) => {
    setText(value);
    setDisableStatus(false);
  };

  return (
    <>
      <div style={{ width: "90%", margin: "0px auto" }}>
        <div style={{ marginTop: "100px" }}>
       
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <h1 style={{ fontSize: "22px", fontWeight: 600 }}>About Us</h1>
            
          </div>
          <ReactQuill
            value={text}
            onChange={handleChange}
            placeholder="Write your about us content here..."
            theme="snow"
            className="mb-4"
            style={{ height: "300px" }} // Adjust height of the editor
          />
        </div>
      </div>
      <div className="flex flex-row justify-end items-center w-full">
        <button
          onClick={data ? updateAboutUsApi : createAboutUsApi} // Dynamically switch between Create and Update
          disabled={disableStatus}
          style={{
            backgroundColor: disableStatus ? "grey" : "blue",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "10px",
            marginTop: "60px",
            marginRight: "80px",
          }}
        >
          {data ? "Update About Us!" : "Create About Us!"} {/* Dynamic button label */}
        </button>
      </div>
      {updating && <Loader />}
    </>
  );
};

export default About;